import React, { ReactNode } from 'react';

import { ThemeModeProvider } from './ThemeModeProvider';
import { ThemeProvider } from './ThemeProvider';

interface GradualThemeProviderProps {
  primaryColor?: string;
  children: ReactNode;
}

export const GradualThemeProvider = ({ children, primaryColor }: GradualThemeProviderProps) => (
  <ThemeModeProvider>
    <ThemeProvider primaryColor={primaryColor}>{children}</ThemeProvider>
  </ThemeModeProvider>
);
